/* istanbul ignore file */
import { createRoot } from 'react-dom/client'

import { i18n } from '@reveni-io/reveni-ui'
import { enTranslations as enReveniUITranslations } from '@reveni-io/reveni-ui'
import { frTranslations as frReveniUITranslations } from '@reveni-io/reveni-ui'
import { deTranslations as deReveniUITranslations } from '@reveni-io/reveni-ui'
import { ptTranslations as ptReveniUITranslations } from '@reveni-io/reveni-ui'
import { itTranslations as itReveniUITranslations } from '@reveni-io/reveni-ui'
import { nlTranslations as nlReveniUITranslations } from '@reveni-io/reveni-ui'
import { koTranslations as koReveniUITranslations } from '@reveni-io/reveni-ui'

import { initMixpanel } from './helpers/mixpanel'
import { initUserEvents } from './helpers/userEvents'
import deTranslations from './i18n/translations/de'
import enTranslations from './i18n/translations/en'
import esTranslations from './i18n/translations/es'
import frTranslations from './i18n/translations/fr'
import itTranslations from './i18n/translations/it'
import koTranslations from './i18n/translations/ko'
import nlTranslations from './i18n/translations/nl'
import ptTranslations from './i18n/translations/pt'
import App from './App'
import { initSentry } from './helpers'

import '@reveni-io/reveni-ui/styles.css'
import './index.css'
import '@reveni-io/reveni-ui/reveni-ui.css'

import './axios.config'

export const i18nInstance = i18n({
  es: { translation: esTranslations },
  en: { translation: { ...enTranslations, ...enReveniUITranslations } },
  fr: { translation: { ...frTranslations, ...frReveniUITranslations } },
  de: { translation: { ...deTranslations, ...deReveniUITranslations } },
  pt: { translation: { ...ptTranslations, ...ptReveniUITranslations } },
  it: { translation: { ...itTranslations, ...itReveniUITranslations } },
  nl: { translation: { ...nlTranslations, ...nlReveniUITranslations } },
  ko: { translation: { ...koTranslations, ...koReveniUITranslations } },
})

const root = createRoot(document.getElementById('root'))
initMixpanel()
initSentry()
initUserEvents()
root.render(<App />)
